import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

import { Spin, Row, Alert, Col, Modal } from 'antd';

import DownloadAndUpload from './DownloadAndUpload';
import { ModalValidationError } from '../../../commonComponents';

import './Step_5.css';

const Rollbar = window.Rollbar;

@withRouter
@inject('translationsStore', 'step5RegistrationStore', 'profileStore', 'registrationStore')
@observer
export default class Step_5 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      download: false
    };

    if (!this.props.step5RegistrationStore.session) {
      this.props.history.push('/registrations');
    }
  }

  async componentDidMount() {
    const { step5RegistrationStore: thisStep, registrationStore: thisRegistration } = this.props;
    this.props.step5RegistrationStore.setMyPosition();
    const vehicleType = thisRegistration.vehicleType ? thisRegistration.vehicleType : 'car';

    if (!!thisStep.subscription) {
      if (!thisStep.subscription.paymentChecked) {
        this.props.history.push('/registration/step_4');
      } else {
        thisRegistration.setPosition(5);

        const assetPlatforms = await thisStep.getAssetPlatforms();
        if (assetPlatforms.hasOwnProperty('munic')) {
          await thisStep
            .heartbeat()
            .catch(error => ({ error }))
            .then(({ error }) => {
              if (error) {
                thisStep.setError(Object.assign({}, thisStep.error, { heartbeat: error }));
                return;
              }
            })
        }
        const prConfigurationForSomePlatform =
          (assetPlatforms.hasOwnProperty('munic') && vehicleType === 'car')
            ? thisStep
                .configureMunic()
                .catch(error => {
                  Rollbar.warning(`munic configuration failure - ${thisStep.asset.imei}`, error, function(err, data) {
                    if (err) {
                      console.log('Error while reporting error to Rollbar: ', err);
                    } else {
                      console.log('Error successfully reported to Rollbar. UUID:', data.result.uuid);
                    }
                  });
                  thisStep.setError(Object.assign({}, thisStep.error, { munic: error }));
                  return { error };
                })
                .then(({ error }) => (error ? 5.1 : 5.2))
            : new Promise(resolve => {
                resolve(5.2);
              });
        prConfigurationForSomePlatform
          .then(nextStatus => (nextStatus > thisStep.currentStatus ? nextStatus : false))
          .then(nextStatus => (nextStatus ? thisStep.updateSubscription(thisStep.updateStatus(nextStatus)) : Promise.resolve({})))
          .then(() => {
            thisRegistration.setPosition(6);
            this.setState({ download: true });
            if (thisStep.subscription.signatureMethod === 'digital') {
              this.goNextForDigitalSigature();
            }
          });

      }
    }

    const errorDescription = this.errorDescription(this.props.step5RegistrationStore.error);
    if (errorDescription && errorDescription.length) {
      Modal.error({
        title: 'Validation error',
        content: (
          <Row>
            {errorDescription.map((d, index) => {
              return <Col key={`error_${index}`}>{d}</Col>;
            })}
          </Row>
        )
      });
    }
  }

  componentWillUnmount() {
    this.props.step5RegistrationStore.resetState();
  }

  goNextForDigitalSigature() {
    const {
      translationsStore: { current: t }
    } = this.props;

    this.props.step5RegistrationStore
      .sendForDigitalSignature()
      .then(() => {
        this.props.history.push('/registration/step_6');
      })
      .catch(error => {
        ModalValidationError(error.reasons || error);
      });
  }

  goNext() {
    const {
      translationsStore: { current: t }
    } = this.props;

    this.props.step5RegistrationStore
      //issue the payment
      .activateZuoraSubscription()
      .then(() => {
        this.props.step5RegistrationStore.updateSubscription(this.props.step5RegistrationStore.createNextStatusAndDeleteSubscription()).then(() => {
          return this.props.step5RegistrationStore.sendValidation().then(() => {
            return this.props.step5RegistrationStore.sendContract().then(() => {
              Modal.info({
                title: `${t['shared']['lblMailSent']} ${this.props.step5RegistrationStore.user.email}`,
                onOk: () => {
                  this.props.history.push('/registration/step_6');
                }
              });
            })
          });
        });
      })
      .catch(error => {
        ModalValidationError(error.reasons || error);
      });
  }

  onConfirm() {
    this.goNext();
  }

  errorDescription(error) {
    let descriptions = [];
    if (error.heartbeat) {descriptions = descriptions.concat(error.heartbeat.details.map(d => d.message));}
    if (error.munic) {descriptions.push(error.munic.message);}
    if (error.activation) {descriptions.push(error.activation.name);}

    return descriptions;
  }

  render() {
    const {
      checking: { heartbeat, payment, munic, subscription }
    } = this.props.step5RegistrationStore;
    const { step5RegistrationStore } = this.props;
    return (
      <Row className="Step_5">
        {
          <Spin
            spinning={heartbeat || payment || munic || subscription}
            tip={
              heartbeat
                ? 'checking device installation...'
                : payment
                  ? 'finalizing the payment...'
                  : munic
                    ? 'configuring the device...'
                    : subscription
                      ? 'updating the subscription...'
                      : null
            }
          >
            {step5RegistrationStore.haserror && <Alert message="Error" description={this.errorDescription(this.props.step5RegistrationStore.error)} type="error" />}
            {!step5RegistrationStore.haserror &&
              this.state.download && (
                <DownloadAndUpload
                  userId={step5RegistrationStore.user._id}
                  assetId={step5RegistrationStore.asset._id}
                  imei={step5RegistrationStore.asset.imei}
                  lastname={step5RegistrationStore.user.lastname}
                  callback={this.onConfirm.bind(this)}
                />
              )}
          </Spin>
        }
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_5/Step_5.js